var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcData04({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "data-04"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon",
    d: "M7.99961 11.6016V7.60156M13.1196 11.8416C12.4127 11.8416 11.8396 12.4146 11.8396 13.1216C11.8396 13.8285 12.4127 14.4016 13.1196 14.4016C13.8265 14.4016 14.3996 13.8285 14.3996 13.1216C14.3996 12.4146 13.8265 11.8416 13.1196 11.8416ZM13.1196 11.8416L13.1196 8.16156C13.1196 7.8081 12.8331 7.52156 12.4796 7.52156H3.51961C3.16615 7.52156 2.87961 7.8081 2.87961 8.16156L2.87961 11.8416M2.87961 11.8416C2.17268 11.8416 1.59961 12.4146 1.59961 13.1216C1.59961 13.8285 2.17268 14.4016 2.87961 14.4016C3.58653 14.4016 4.15961 13.8285 4.15961 13.1216C4.15961 12.4146 3.58653 11.8416 2.87961 11.8416ZM7.99961 14.4016C7.29268 14.4016 6.71961 13.8285 6.71961 13.1216C6.71961 12.4146 7.29268 11.8416 7.99961 11.8416C8.70653 11.8416 9.27961 12.4146 9.27961 13.1216C9.27961 13.8285 8.70653 14.4016 7.99961 14.4016ZM3.99961 4.80156H11.9996C12.4414 4.80156 12.7996 4.44339 12.7996 4.00156V2.40156C12.7996 1.95973 12.4414 1.60156 11.9996 1.60156H3.99961C3.55778 1.60156 3.19961 1.95973 3.19961 2.40156V4.00156C3.19961 4.44339 3.55778 4.80156 3.99961 4.80156Z",
    stroke: "#4A5467",
    strokeWidth: 1.33,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcData04);
export default __webpack_public_path__ + "static/media/ic-data-04.7b58e20c9141e4ffbcb18dadb6eaebf8.svg";
export { ForwardRef as ReactComponent };